import { initializeApp } from 'firebase/app'
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail, signOut, onAuthStateChanged } from 'firebase/auth'
import { getDatabase, ref, onValue, set, update, push, remove } from 'firebase/database'
import { getFunctions, httpsCallable } from 'firebase/functions'
import * as localDb from './localDb.js'

const env = process.env
export const OWNER_EMAIL = (env.REACT_APP_OWNER_EMAIL || 'nyiro.levente@gmail.com').toLowerCase()

// No Firebase config in .env (or `npm run start:local`) → local mode: no login, data kept in this browser.
export const LOCAL = env.REACT_APP_LOCAL === 'true' || !(env.REACT_APP_FIREBASE_API_KEY && env.REACT_APP_FIREBASE_DATABASE_URL)

const app = LOCAL ? null : initializeApp({
  apiKey: env.REACT_APP_FIREBASE_API_KEY,
  authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: env.REACT_APP_FIREBASE_APP_ID,
})
const auth = app && getAuth(app)
const db = app && getDatabase(app)
const functions = app && getFunctions(app, env.REACT_APP_FUNCTIONS_REGION || 'europe-west1')

const LOCAL_USER = { email: OWNER_EMAIL, local: true }
export const onAuth = (cb) => (LOCAL ? (cb(LOCAL_USER), () => {}) : onAuthStateChanged(auth, cb))
export const signIn = (email, password) => signInWithEmailAndPassword(auth, email, password)
export const resetPassword = (email) => sendPasswordResetEmail(auth, email)
export const logOut = () => (LOCAL ? Promise.resolve() : signOut(auth))

// Everything lives under one JSON tree: /money
const ROOT = 'money'
const r = (path = '') => ref(db, path ? `${ROOT}/${path}` : ROOT)

export const subscribe = LOCAL ? localDb.subscribe : (cb, onError) => onValue(r(), (snap) => cb(snap.val() || {}), onError)
export const setAt = LOCAL ? localDb.setAt : (path, value) => set(r(path), value)
export const updateAt = LOCAL ? localDb.updateAt : (path, value) => update(r(path), value)
export const removeAt = LOCAL ? localDb.removeAt : (path) => remove(r(path))
export const add = LOCAL ? localDb.add : async (path, value) => (await push(r(path), value)).key
export const replaceAll = LOCAL ? localDb.replaceAll : (value) => set(r(), value)

export const syncCoinbase = () => (LOCAL
  ? Promise.reject(new Error('Coinbase sync runs as a Firebase function, so it only works with Firebase configured in .env.'))
  : httpsCallable(functions, 'syncCoinbase')())

// {} refreshes the plugs, { did, on } switches one.
export const xiaomiPlugs = (payload = {}) => (LOCAL
  ? Promise.reject(new Error('Smart plugs run through a Firebase function, so they only work with Firebase configured in .env.'))
  : httpsCallable(functions, 'xiaomiPlugs')(payload))
